import {
  Box,
  Stack,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';

import { t } from 'i18next';
import ShowContainer from '../../../../../components/material-ui/ShowContainer';
import Table from '../../../../../components/material-ui/adaptive/Table';
import MyTableCell from '../../../../../components/material-ui/adaptive/MyTableCell';
import CusTooltip from '../../../../../components/material-ui/CusTooltip';
import MyTableZeroPCell from '../../../../../components/material-ui/adaptive/MyTableZeroPCell';
import { useAppSelector } from '../../../../../store';
import { useDispatch } from 'react-redux';
import { setSelectGame } from '../../../../../store/apps/gameProvidersSlice';
import CusItemTooltip from '../../../../../components/material-ui/CusItemTooltip';
import { VisibilityOff, Whatshot } from '@mui/icons-material';
import useColor from '../../../../../hooks/site/useColor';
import TypographyText from '../../../../../components/material-ui/table/TypographyText';
import useGameProviderUtils from '../../../../../hooks/site/game/providers/useGameProviderUtils';

export default function CategoriesGames({ selectCategoryId, categoryName }) {
  const dispatch = useDispatch();
  const { text } = useColor();
  const { getSourceName } = useGameProviderUtils();

  const selectGameId = useAppSelector((state) => state.gameProviders.selectGame.id);
  const categoryId = useAppSelector((state) => state.gameProviders.categoryGames.categoryId);
  const categoryGames = useAppSelector((state) => state.gameProviders.categoryGames.list);

  const games = categoryId == selectCategoryId ? categoryGames : [];

  const onGameClick = (game) => {
    dispatch(
      setSelectGame({
        id: game[0],
        name: game[1],
        originName: game[2],
        uuid: game[3],
        source: game[4],
        image: game[5],
        type: game[6],
        provider: game[7],
        hasFreeSpins: game[8],
        freespinFullDay: game[9],
        priority: game[10],
        enabled: game[11],
        hit: game[12],
        providerName: game[13],
        sourceGameId: game[14],
        categoryId
      })
    );
  };

  const displayCategoryName = categoryName ? `"${categoryName}"` : '';

  return (
    <Stack display={'flex'} direction={'column'} gap={1.5}>
      <TableContainer
        sx={{
          maxHeight: 'calc(100svh - 440px)',
          minHeight: `400px`,
          overflow: 'auto'
        }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <MyTableZeroPCell sx={{ px: 0.5 }} style={{ textAlign: 'center', border: 'none' }}>
                <ShowContainer condition={games.length}>
                  <Box pb={0.5} pr={0.5}>
                    <CusTooltip text={'Priority'} />
                  </Box>
                </ShowContainer>
              </MyTableZeroPCell>
              <MyTableCell
                isLess
                sx={{ pt: 0 }}
                style={{ textAlign: 'center', border: 'none' }}
                colSpan={3}>
                <Typography fontWeight={900} fontSize={16}>
                  {t('List of games category')} {displayCategoryName}
                </Typography>
              </MyTableCell>
            </TableRow>
          </TableHead>
          <ShowContainer
            condition={games.length}
            plug={
              <TableBody>
                <TableRow>
                  <MyTableZeroPCell isSmall></MyTableZeroPCell>
                  <MyTableCell isSmall>
                    <Typography fontSize={14} color="textSecondary" style={{ textAlign: 'center' }}>
                      {t(
                        categoryId
                          ? 'There are no games in the selected category yet.'
                          : 'Games will appear after selecting a category.'
                      )}
                    </Typography>
                  </MyTableCell>
                  <MyTableZeroPCell isSmall></MyTableZeroPCell>
                  <MyTableZeroPCell isSmall></MyTableZeroPCell>
                </TableRow>
              </TableBody>
            }>
            <TableBody>
              {games.map((game) => {
                const gameId = game[0];
                const gameName = game[1];
                const gameDop = `(${getSourceName(game[4])} -> ${game[13]})`;
                const isVisible = game[11];
                const isHit = game[12];

                return (
                  <TableRow
                    key={gameId}
                    selected={gameId == selectGameId}
                    onClick={() => onGameClick(game)}>
                    <MyTableCell isLess sx={{ textAlign: 'center' }}>
                      {game[10]}
                    </MyTableCell>
                    <MyTableCell isSmall sx={{ px: 1 }}>
                      <TypographyText fontSize={13}>{gameName}</TypographyText>{' '}
                      <TypographyText color="textSecondary">{gameDop}</TypographyText>
                    </MyTableCell>
                    <MyTableCell isLess sx={{ p: !isVisible ? 0 : undefined }}>
                      <ShowContainer condition={!isVisible}>
                        <CusItemTooltip
                          text={'she_hidden'}
                          elem={<VisibilityOff sx={{ width: 16, height: 16, color: text.third }} />}
                        />
                      </ShowContainer>
                    </MyTableCell>
                    <MyTableCell isLess sx={{ p: !isHit ? 0 : undefined }}>
                      <ShowContainer condition={isHit}>
                        <CusItemTooltip
                          text={'Hit'}
                          elem={<Whatshot sx={{ width: 16, height: 16, color: text.third }} />}
                        />
                      </ShowContainer>
                    </MyTableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </ShowContainer>
        </Table>
      </TableContainer>
    </Stack>
  );
}
